import { render, staticRenderFns } from "./_top_mabr.vue?vue&type=template&id=f0c1a056&"
import script from "./_top_mabr.vue?vue&type=script&lang=js&"
export * from "./_top_mabr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports